import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿No me llevo bien con la tecnología, es difícil de usar?',
  answer: '¡Para nada! Está diseñado para ser tan fácil como anotar en un cuaderno, pero con la potencia de una computadora. Además, incluimos un Manual de Usuario, Video Tutoriales paso a paso, y lo más importante: Soporte VIP Directo por WhatsApp con nuestro equipo. Nunca estarás solo en el proceso.'
}, {
  question: '¿Tengo que pagar mensualidades por cada computadora?',
  answer: 'No. Al ser un archivo central, haces un ÚNICO PAGO de $24.99 y puedes hacer las copias que necesites para tus 3 computadoras de caja o para varias sucursales sin pagar un centavo extra en licencias.'
}, {
  question: 'Si no me funciona, ¿hacen devoluciones?',
  answer: 'Al ser un producto digital descargable que queda en tu poder de por vida (junto con todos los bonos de regalo), no manejamos devoluciones. ¡Pero por eso te damos Soporte VIP! Si te trancas registrando un producto o haciendo un cierre de caja, nos escribes al WhatsApp y te explicamos hasta que lo domines a la perfección.'
}, {
  question: '¿Cómo recibo el Masterkit después de pagar?',
  answer: 'Inmediatamente después de confirmar tu pago (Pago Móvil, Binance o Tarjeta), te enviaremos directamente a tu WhatsApp y correo el archivo maestro de Excel, tus videos tutoriales y los enlaces a tus bonos de regalo. Todo automático y rápido.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 md:px-6 lg:px-8 max-w-4xl mx-auto relative" data-id="element-55">
      <div className="text-center mb-16" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-16 h-16 bg-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-cyan-500/20" data-id="element-57">
          <HelpCircle className="w-8 h-8 text-cyan-400" data-id="element-58" />
        </motion.div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white tracking-tight mb-4" data-id="element-59">
          Preguntas <span className="text-cyan-400" data-id="element-60">Frecuentes</span>
        </h2>
      </div>

      <div className="space-y-4" data-id="element-61">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-[#0a0a0a] border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-cyan-500/30' : 'border-white/5 hover:border-white/10'}`} data-id="element-62">
              <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left group" data-id="element-63">
                <h3 className={`font-bold text-lg md:text-xl transition-colors duration-300 pr-8 ${isOpen ? 'text-cyan-400' : 'text-white group-hover:text-cyan-200'}`} data-id="element-64">
                  {faq.question}
                </h3>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-cyan-500/20 text-cyan-400' : 'bg-white/5 text-gray-400 group-hover:bg-white/10'}`} data-id="element-65">
                  <ChevronDown className="w-5 h-5" data-id="element-66" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-67">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-68">
                    <div className="px-6 pb-6 pt-2 text-gray-400 text-lg leading-relaxed border-t border-white/5 mt-2" data-id="element-69">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>
    </section>;
}